import utils from 'utils'
import synInvoicePage from './view/synInvoiceModal.html'
import synProgressPage from './view/synProgress.html'
import statusProgress from './view/statusProgress.html'
import downloadProgress from './view/downloadProgress.html'
import chooseUkeyModal from './view/chooseUkeyModal.html'
class poolListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService, exportSettingService, getOvatAmtService, $state, $filter) {
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        const types = ['invoice_source', 'pool_inv_type', 'ovat_tax_rate', 'abnormal_voucher_status', 'red_lock_flag', 'vat_usage_code', 'entry_status', 'export_tax_refund_code', 'vat_preference_purpose', 'excise_usage_code', 'oil_abnormality', 'specific_element','ivat_source_app_id']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            $scope.dictData.is_red_all = [
                {
                    enumTypeCode: null,
                    enumName: '蓝票',
                    enumCode: '0',
                },
                {
                    enumTypeCode: null,
                    enumName: '红票',
                    enumCode: '1',
                },
            ]
            $scope.dictData.invoice_status = [
                {
                    enumCode: '1',
                    enumName: '正常',
                },
                {
                    enumCode: '2',
                    enumName: '已作废',
                },
                {
                    enumCode: '3',
                    enumName: '全部红冲',
                },
                {
                    enumCode: '4',
                    enumName: '部分红冲',
                },
            ]
        })
        // 选中的发票
        $scope.selectedInvoices = []
        // 导出设置
        $scope.exportCollapsed = false
        $scope.exportSetting = function exportSetting() {
            exportSettingService($scope.exportID, $scope.exportConfig)
        }
        $scope.treeConfig = {
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.searchData = {
            orgArr: [$scope.userInfo.org],
        }
        // const aMonth = utils.genPeriodByMonth()
        const nowDate = new Date()
        let nowYears = nowDate.getFullYear()
        let nowMoths = nowDate.getMonth()
        let _nowDate = new Date(nowYears, nowMoths, 1) //本月第一天

        const aMonth = {
            start: $filter('date')(_nowDate, 'yyyy-MM-dd'),
            end: $filter('date')(nowDate, 'yyyy-MM-dd'),
        }
        $scope.param = {
            param: {
                invoiceDateBegin: aMonth.start,
                invoiceDateEnd: aMonth.end,
                updateTimeBegin: aMonth.start,
                updateTimeEnd: aMonth.end,
                invoiceOrgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                invType: '',
                electricInvoiceNum: '',
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
                invoiceSource: '',
                custNameCreditCode: '',
                openPeople: '',
                isRed: '',
                taxRate: '',
            },
            pageNum: 1,
            pageSize: 10,
            orderMap: {},
        }

        $scope.reset = function () {
            $scope.param.param = {
                invoiceDateBegin: aMonth.start,
                invoiceDateEnd: aMonth.end,
                updateTimeBegin: aMonth.start,
                updateTimeEnd: aMonth.end,
                invoiceOrgIdList: [$scope.userInfo.org.orgId],
                selectedOrgs: [$scope.userInfo.org],
                invType: '',
                electricInvoiceNum: '',
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
                invoiceSource: '',
                custNameCreditCode: '',
                openPeople: '',
                isRed: '',
                taxRate: '',
            }
            getOrgList()
        }
        $scope.orgList = []
        function getOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
        }
        $scope.exportConfig = {
            version: 1.201,
            detailInfo: [
                {
                    label: '机构名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '简称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },

                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '是否享受优惠政策',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '优惠政策类型',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税收分类编码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
            ],
            mainInfo: [
                {
                    label: '机构名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方开户银行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户银行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数据来源',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '关联销售单',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '主商品名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '同步时间',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '异常凭证状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '红字锁定标识',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票用途',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '入账状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '出口退税类型',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '增值税优惠用途',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '消费税用途',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '成品油异常标识',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '状态更新时间',
                    selected: true,
                    defaultWord: true,
                },
            ],
        }
        $scope.exportID = 301
        $scope.batchDropdownConfig = {
            btnText: '下载',
            options: [
                {
                    text: '下载OFD',
                    hasPermit: 'outputInvoicePoolDownload',
                    handler() {
                        $scope.downloadModel('OFD')
                    },
                },
                {
                    text: '下载PDF',
                    hasPermit: 'outputInvoicePoolDownload',
                    handler() {
                        $scope.downloadModel('PDF')
                    },
                },
                {
                    text: '下载XML',
                    hasPermit: 'outputInvoicePoolDownload',
                    handler() {
                        $scope.downloadModel('XML')
                    },
                },
            ],
        }
        $scope.tableDropdownConfig = [
            {
                label: '预览',
                handler(item) {
                    let url
                    if ((item.invType == '61' || item.invType == '62') && item.specificElements != '03' && item.specificElements != '06') {
                        // 金四 非特定业务发票
                        url = 'outputManage.invoicePool.outputInvoicePool.tax4Detail'
                    } else if ((item.invType == '61' || item.invType == '62') && item.specificElements == '06') {
                        // 不动产租赁服务
                        url = 'outputManage.invoicePool.outputInvoicePool.realEstateDetail'
                    } else if ((item.invType == '61' || item.invType == '62') && item.specificElements == '03') {
                        // 建筑服务
                        url = 'outputManage.invoicePool.outputInvoicePool.constructionDetail'
                    } else {
                        // 金三发票
                        url = 'outputManage.invoicePool.outputInvoicePool.tax3Detail'
                    }
                    window.open(
                        $state.href(
                            url,
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        ),
                        '_blank'
                    )
                },
                showWhile(item, hasPermit) {
                    return hasPermit('outputInvoicePoolView')
                },
            },
            {
                label: '下载OFD',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=2&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('outputInvoicePoolDownload') && item.ofdDownloadStatus != '3'
                },
            },
            {
                label: '下载PDF',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=1&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('outputInvoicePoolDownload') && item.pdfDownloadStatus != '3'
                },
            },
            {
                label: '下载XML',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=3&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('outputInvoicePoolDownload') && item.xmlDownloadStatus != '3'
                },
            },
            {
                label: '状态更新',
                handler(item) {
                    $scope.statusUpdate(item, 1)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('outputInvoicePoolView')
                },
            },
        ]
        $scope.orderMap = {}
        $scope.profileType = '300'
        $scope.customizedConfig = {
            version: 1.03,
            queryForm: [
                {
                    // 0
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    //5
                    label: '发票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '数据来源',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方名称/购方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票人',
                    selected: false,
                    default: false,
                },
                {
                    //10
                    label: '发票性质',
                    selected: false,
                    default: false,
                },
                {
                    label: '税率',
                    selected: false,
                    default: false,
                },
                {
                    label: '同步时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '异常凭证状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '红字锁定标识',
                    selected: false,
                    default: false,
                },
                {
                    //15
                    label: '发票用途',
                    selected: false,
                    default: false,
                },
                {
                    label: '入账状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '出口退税类型',
                    selected: false,
                    default: false,
                },
                {
                    label: '增值税优惠用途',
                    selected: false,
                    default: false,
                },
                {
                    label: '消费税用途',
                    selected: false,
                    default: false,
                },
                {
                    //20
                    label: '成品油异常标识',
                    selected: false,
                    default: false,
                },
                {
                    //20
                    label: '特定业务类型',
                    selected: false,
                    default: false,
                }
            ],
            table: [
                {
                    //0
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    //5
                    label: '销方名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方地址',
                    selected: false,
                    default: false,
                },
                {
                    //10
                    label: '购方电话',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方开户银行',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    default: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    default: true,
                },
                {
                    //15
                    label: '价税合计',
                    selected: true,
                    default: true,
                },
                {
                    label: '税率',
                    selected: true,
                    default: true,
                },
                {
                    label: '备注',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    //20
                    label: '开票人',
                    selected: true,
                    default: true,
                },
                {
                    label: '数据来源',
                    selected: true,
                    default: true,
                },
                {
                    label: '关联销售单',
                    selected: true,
                    default: true,
                },
                {
                    label: '主商品名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '同步时间',
                    selected: false,
                    default: false,
                },
                {
                    //25
                    label: '异常凭证状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '红字锁定标识',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票用途',
                    selected: false,
                    default: false,
                },
                {
                    label: '入账状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '出口退税类型',
                    selected: false,
                    default: false,
                },
                {
                    //30
                    label: '增值税优惠用途',
                    selected: false,
                    default: false,
                },
                {
                    label: '消费税用途',
                    selected: false,
                    default: false,
                },
                {
                    label: '成品油异常标识',
                    selected: false,
                    default: false,
                },
                {
                    label: '状态更新时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '特定业务类型',
                    selected: false,
                    default: false,
                },
            ],
        }
        httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
            if (res.data.value) {
                const { orderMap } = JSON.parse(res.data.value)
                if (orderMap) {
                    $scope.orderMap = orderMap
                }
            }
            if ($scope.orderMap.sortKey) {
                $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            }
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
            getOrgList()
        })
        function queryList(msg) {
            $scope.param.param.invoiceOrgIdList = $scope.param.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            const openLoading = window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest
                .post_findListByPagePool($scope.param)
                .then((res) => {
                    $scope.invoiceList = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.selectedInvoices = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                    if (msg) {
                        logger.logSuccess(msg)
                    }
                })
            getData()
        }
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })
        function getData() {
            httpRequest.post_getInvoicePoolStatics($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 表头排序
        $scope.orderMap = initSortService('poolParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
        }
        $scope.search = function () {
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                'poolParam',
                JSON.stringify({
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage.poolParam
                        ? JSON.parse(sessionStorage.poolParam).param
                        : {
                              invoiceDateBegin: aMonth.start,
                              invoiceDateEnd: aMonth.end,
                              updateTimeBegin: aMonth.start,
                              updateTimeEnd: aMonth.end,
                              invoiceOrgIdList: [$scope.userInfo.org.orgId],
                              invType: '',
                              electricInvoiceNum: '',
                              invoiceCode: '',
                              invoiceNumber: '',
                              invoiceStatus: '',
                              invoiceSource: '',
                              custNameCreditCode: '',
                              openPeople: '',
                              isRed: '',
                              taxRate: '',
                          },
                })
            )
            queryList()
        }
        //同步
        $scope.synchronizationModel = function () {
            const modalInstance = $uibModal.open({
                template: synInvoicePage,
                controller: 'synInvoiceCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-hg',
            })
            modalInstance.result.then((data) => {
                $uibModal
                    .open({
                        templateUrl: 'choseUkeyModel.html',
                        openedClass: 'mod-modal mod-modal-md',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'logger',
                            'httpRequest',
                            function ($scope, $uibModalInstance, logger, httpRequest) {
                                httpRequest.post_qryUkeyListOfOrgIds([data.orgId]).then((res) => {
                                    $scope.ukeyList = res.data.value
                                })
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.dismiss()
                                }
                                $scope.ok = function ok() {
                                    if (!$scope.dataInfo.ukeyId) return logger.logError('开票点不能为空！')
                                    httpRequest.post_ukeyLoginCheck($scope.dataInfo.ukeyId).then((res) => {
                                        data.ukeyId = $scope.dataInfo.ukeyId
                                        $uibModalInstance.close(data)
                                    })
                                }
                            },
                        ],
                        resolve: {},
                    })
                    .result.then((data) => {
                        console.log(data)
                        $uibModal
                            .open({
                                template: synProgressPage,
                                controller: 'synProgressCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-hg',
                                resolve: {
                                    items1() {
                                        // data.drawerId = drawerId[0].drawerId
                                        console.log(data)
                                        return data
                                    },
                                },
                            })
                            .result.then((data) => {
                                queryList()
                            })
                    })

                // $uibModal
                //     .open({
                //         template: synProgressPage,
                //         controller: 'synProgressCtrl',
                //         backdrop: 'static',
                //         openedClass: 'mod-modal mod-modal-hg',
                //         resolve: {
                //             items1() {
                //                 return data
                //             },
                //         },
                //     })
                //     .result.then((data) => {
                //         queryList()
                //     })
            })
        }
        // 过滤同机构数据
        function filterDuplicateObjects(array, key) {
            const seen = new Set()
            return array.filter((item) => {
                const isDuplicate = seen.has(item[key])
                seen.add(item[key])
                return !isDuplicate
            })
        }
        //状态更新
        $scope.statusUpdate = async function (item, type) {
            let orgIdList = []
            if (type == '1') {
                orgIdList = [item.invoiceOrgId]
            } else {
                if ($scope.selectedInvoices.length === 0) return logger.logError('还未选择数据')
                const filteredArray = filterDuplicateObjects($scope.selectedInvoices, item.invoiceOrgId)
                filteredArray.forEach((item) => {
                    orgIdList.push(item.invoiceOrgId)
                })
            }
            $uibModal
                .open({
                    templateUrl: 'choseUkeyModel.html',
                    openedClass: 'mod-modal mod-modal-md',
                    animation: true,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        'httpRequest',
                        function ($scope, $uibModalInstance, logger, httpRequest) {
                            $scope.dataInfo = {
                                ukeyId: '',
                            }
                            httpRequest.post_qryUkeyListOfOrgIds(orgIdList).then((res) => {
                                $scope.ukeyList = res.data.value
                            })
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                if (!$scope.dataInfo.ukeyId) return logger.logError('开票点不能为空！')
                                let data = {
                                    ukeyId: $scope.dataInfo.ukeyId,
                                    ukeyList: $scope.ukeyList,
                                }
                                httpRequest.post_ukeyLoginCheck($scope.dataInfo.ukeyId).then((res) => {
                                    $uibModalInstance.close(data)
                                })
                            }
                        },
                    ],
                    resolve: {},
                })
                .result.then((data) => {
                    let ukeyId = data.ukeyId
                    let ukeyList = data.ukeyList
                    if (type == '1') {
                        //行操作状态更新
                        let data = {
                            invoiceId: item.invoiceId,
                            ukeyId: ukeyId,
                        }
                        httpRequest.post_updateStatusOne(data).then((res) => {
                            logger.logSuccess('状态更新成功。')
                            setTimeout(() => {
                                queryList()
                            }, 500)
                        })
                    } else {
                        let errData = $scope.selectedInvoices.filter((item) => {
                            return item.invoiceOrgId != $scope.selectedInvoices[0].invoiceOrgId
                        })
                        const fliterukey = ukeyList.filter((item) => item.ukeyId === ukeyId)
                        if (errData.length > 0 && (fliterukey[0].manageType == '6' || fliterukey[0].manageType == '8')) return logger.logError('所选发票数据属于多个机构，批量状态更新仅支持单机构')
                        const invoiceId = []
                        for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                            invoiceId.push($scope.selectedInvoices[i].invoiceId)
                        }
                        let data = {
                            authorizeId: $scope.selectedInvoices[0].authorizeId,
                            invoiceId: invoiceId,
                            ukeyId: ukeyId,
                        }
                        $uibModal
                            .open({
                                template: statusProgress,
                                controller: 'statusProgressCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-hg',
                                resolve: {
                                    items1() {
                                        return data
                                    },
                                },
                            })
                            .result.then((data) => {
                                queryList()
                            })
                    }
                })
            // const ukeyId = await chooseUkey('选择开票点')
            // if (!ukeyId) return
            // if (type == '1') {
            //     //行操作状态更新
            //     let data = {
            //         invoiceId: item.invoiceId,
            //         ukeyId: ukeyId,
            //     }
            //     httpRequest.post_updateStatusOne(data).then((res) => {
            //         logger.logSuccess('状态更新成功。')
            //         setTimeout(() => {
            //             queryList()
            //         }, 500)
            //     })
            // } else {
            //     if ($scope.selectedInvoices.length === 0) {
            //         logger.logError('还未选择数据')
            //         return
            //     }
            //     const invoiceId = []
            //     for (let i = 0; i < $scope.selectedInvoices.length; i++) {
            //         invoiceId.push($scope.selectedInvoices[i].invoiceId)
            //     }
            //     let data = {
            //         authorizeId: $scope.selectedInvoices[0].authorizeId,
            //         invoiceId: invoiceId,
            //         ukeyId: ukeyId,
            //     }
            //     $uibModal
            //         .open({
            //             template: statusProgress,
            //             controller: 'statusProgressCtrl',
            //             backdrop: 'static',
            //             openedClass: 'mod-modal mod-modal-hg',
            //             resolve: {
            //                 items1() {
            //                     return data
            //                 },
            //             },
            //         })
            //         .result.then((data) => {
            //             queryList()
            //         })
            // }
        }
        function chooseUkey(title) {
            return $uibModal
                .open({
                    template: chooseUkeyModal,
                    controller: 'chooseUkeyModalCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { title }
                        },
                    },
                })
                .result.then(
                    (ukeyId) => {
                        return ukeyId
                    },
                    () => {
                        return ''
                    }
                )
        }
        //下载
        $scope.downloadModel = function (fileType) {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('还未选择数据')
                return
            }
            for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                if ($scope.selectedInvoices[0].invoiceOrgId !== $scope.selectedInvoices[i].invoiceOrgId) {
                    return logger.logError('不同机构的发票不支持同时下载，请选择机构名称相同的发票进行批量下载。')
                }
                if (fileType == 'OFD' && $scope.selectedInvoices[i].ofdDownloadStatus == '3') {
                    return logger.logError('您选择数据中存在无OFD文件的数据，不支持下载OFD，请重新选择！')
                } else if (fileType == 'PDF' && $scope.selectedInvoices[i].pdfDownloadStatus == '3') {
                    return logger.logError('您选择数据中存在无PDF文件的数据，不支持下载PDF，请重新选择！')
                } else if (fileType == 'XML' && $scope.selectedInvoices[i].xmlDownloadStatus == '3') {
                    return logger.logError('您选择数据中存在无XML文件的数据，不支持下载XML，请重新选择！')
                }
            }
            let invoiceIds = $scope.selectedInvoices.map((ele) => {
                return ele.invoiceId
            })
            /*const modalInstance = $uibModal.open({
                template: downloadProgress,
                controller: 'downloadProgressCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-hg',
                resolve: {
                    items1() {
                        return data
                    },
                },
            })
            modalInstance.result.then((data) => {
                queryList()
            })*/
            let getListApi
            let invoiceFileType //  PDF:1,OFD:2,XML:3
            if(fileType == 'OFD'){
                getListApi = 'post_downOfdInvoiceFile'
                invoiceFileType='2'
            }else if(fileType == 'PDF'){
                getListApi = 'post_downPdfInvoiceFile'
                invoiceFileType='1'
            }else if(fileType == 'XML'){
                getListApi = 'post_downXmlInvoiceFile'
                invoiceFileType='3'
            }else {
                return logger.logError('您选择的文件下载格式不存在，请重新选择！')
            }
            let data = {
                invoiceIds: invoiceIds,
                invoiceFileType: invoiceFileType,
            }
            const openLoading = window.layer.msg('正在下载，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest[getListApi](data).then((res) => {
                console.log(res)
                if(res.data.success){
                    let downCount = res.data.value.downCount //已下载数量
                    invoiceIds =  res.data.value.invoiceIds
                    if(downCount > 0){
                        utils.post_downLoad({
                            invoiceIds,
                            invoiceFileType,
                        }, `${host.etcloudOvat}tax4/ovatTax4InvoicePool/downloadTax4InvoiceBach?accessToken=${localStorage.getItem('id_token')}`, '')
                    }else {
                        return logger.logError('您选择的发票无符合下载条件的数据，请检查！')
                    }
                }
            }).finally(() => {
                window.layer.close(openLoading)
            })
        }
        // 查看关联销售单
        $scope.relatedBill = function (item) {
            if (item.billNum === 0) {
                return
            }
            if (item.foreInvoiceId === undefined) {
                return
            }
            $state.go('outputManage.invoicePool.outputInvoicePool.relatedBill', {
                invoiceId: item.foreInvoiceId,
                invType: item.invType,
            })
        }
        // 导出
        $scope.exportInvoic = function () {
            let getdata = $.extend({}, $scope.param.param)
            const idArr = []
            $scope.selectedInvoices.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            getdata.idList = idArr.join(',')
            let url = `${host.etcloudOvat}tax4/ovatTax4InvoicePool/exportToExcel`
            url = `${url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i = 0; i < $scope.param.orderMap.length; i++) {
                getdata.sortField = `${i}:${$scope.param.orderMap[i]}`
            }
            utils.post_downLoad(getdata, url)
        }
        $scope.goCollectRecord = function (){
            $state.go('input.invoicePool.inputInvoicePool.collectRecord',{invoiceSource: 1})
        }
    }
}

poolListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService', 'exportSettingService', 'getOvatAmtService', '$state', '$filter']
export default poolListCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/invoicePool/outputInvoicePool/list.js